import { useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { API, setAuthToken } from "./config/api";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./context/userContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/style.css";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import UserHome from "./pages/user/UserHome";
import DetailProduct from "./pages/user/DetailProduct";
import MyProfile from "./pages/user/MyProfile";
import ListProduct from "./pages/admin/ListProduct";
import AdminHome from "./pages/admin/AdminHome";
import ListCategory from "./pages/admin/ListCategory";
import Complain from "./pages/admin/Complain";
import UserComplain from "./pages/user/UserComplain";
import EditCategory from "./pages/admin/EditCategory";
import EditProduct from "./pages/admin/EditProduct";
import AddProduct from "./pages/admin/AddProduct";
import AddCategory from "./pages/admin/AddCategory";
import PrivateRoute from "./components/PrivateRoute";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

function App() {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(UserContext);

  console.log("Log State di App : ", state);

  useEffect(() => {
    if (state.isLogin === false) {
      navigate("/");
    } else {
      if (state.user.status === "admin") {
        navigate("/admin");
      } else if (state.user.status === "customer") {
        navigate("/user");
      }
    }
  }, [state]);

  const checkUser = async () => {
    try {
      const config = {
        method: "GET",
        headers: {
          Authorization: "Basic " + localStorage.token,
        },
      };

      const response = await API.get("/check-auth", config);

      if (response.status === 404) {
        return dispatch({
          type: "AUTH_ERROR",
        });
      }

      let payload = response.data.data.user;
      payload.token = localStorage.token;

      dispatch({
        type: "USER_SUCCESS",
        payload,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (localStorage.token) {
      checkUser();
    }
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Private Route */}
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/user" element={<UserHome />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/complain-user" element={<UserComplain />} />
          <Route path="/admin" element={<AdminHome />} />
          <Route path="/category" element={<ListCategory />} />
          <Route path="/product" element={<ListProduct />} />
          <Route path="/detail-product/:id" element={<DetailProduct />} />
          <Route path="/complain-admin" element={<Complain />} />
          <Route path="/edit-category/:id" element={<EditCategory />} />
          <Route path="/edit-product/:id" element={<EditProduct />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/add-category" element={<AddCategory />} />
        </Route>

        {/* <Route path="/logout" element={<Login />} /> */}
      </Routes>
    </>
  );
}

export default App;
